<template>
  <div
    class="coupon-banner"
  >
    <img
      class="coupon-banner__gift"
      src="https://cdn-image.bestdealer.com/app-bestdealer/1688/coupon/gift.png"
    >
    Get
    <IntlCurrency
      class="coupon-banner__currency"
      currency="us"
      :size="14"
      color="#052785"
    />
    <span class="coupon-banner__amount">5</span>
    <span class="coupon-banner__off">Off</span>
    <span class="coupon-banner__gradient">Your Order!</span>
    <div class="coupon-banner__get">
      Get it
    </div>
  </div>
</template>

<script setup>
</script>

<style lang="less" scoped>
.coupon-banner {
  padding: 12px;
  display: flex;
  align-items: center;
  border-radius: 8px;
  background-color: #DFE8FB;
  font-family: mon-600;
  font-size: 14px;
  color: #052784;
  cursor: pointer;

  &__gift {
    margin-right: 8px;
    width: 28px;
    height: 28px;
  }

  &__currency {
    margin-left: 4px;
  }

  &__amount {
    font-family: mon-700;
    padding-left: 3px;
    padding-right: 2px;
    font-size: 16px;
    color: #F55745;
  }

  &__gradient {
    margin-left: 4px;
    background: linear-gradient(90deg, #052784 0%, #733A5F 50%, #E14D39 100%);
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
  }

  &__get {
    margin-left: auto;
    padding: 6px 12px;
    border-radius: 14px;
    border: 1px solid #052784;
    font-size: 12px;
  }
}
</style>
